import { render, staticRenderFns } from "./secondPage.vue?vue&type=template&id=0d1351ba"
import script from "./secondPage.vue?vue&type=script&lang=js"
export * from "./secondPage.vue?vue&type=script&lang=js"
import style0 from "./secondPage.vue?vue&type=style&index=0&id=0d1351ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports